import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import NotebookPanel from "@/components/NotebookPanel";
import { Card } from "@/components/ui/card";

export default function MyNotebook() {
  const [params] = useSearchParams();
  const [classes, setClasses] = useState([]);
  const [active, setActive] = useState(params.get("group") || "");

  useEffect(() => {
    api.get("/notebook/mine").then((r) => {
      const list = r.data || [];
      setClasses(list);
      setActive((prev) => prev || list[0]?.id || "");
    });
  }, []);

  const current = classes.find((c) => c.id === active);

  return (
    <div>
      <PageHeader
        title={current ? `Notebook · ${current.name}` : "Mi Notebook"}
        subtitle="Los documentos de tu clase: escribí acá junto con tu profe"
        testId="my-notebook-header"
      />

      {active ? (
        <NotebookPanel key={active} groupId={active} />
      ) : (
        <Card className="p-10 text-center text-slate-500" data-testid="my-notebook-empty">
          Todavía no estás matriculado en ninguna clase
        </Card>
      )}
    </div>
  );
}
